/**
 * Auto-generated by generate-role-defaults.ts – DO NOT EDIT MANUALLY.
 * Generated on: 2025-11-13T22:51:10.575Z
 *
 * This file contains default role selections for all taxonomies:
 * - Default taxonomy
 * - All RICS K10 taxonomies
 * - All RICS K50 taxonomies
 */

import type { TreeFilter } from '../next/CustomDash/filters/types/filters';

// Default // Default
export const GENERATED_DEFAULT_CUSTOM_ROLE_DEFAULT: TreeFilter['selections'] = [
  {
    id: '2_2',
    name: 'Accountant',
    levelId: 'role_k150',
  },
  {
    id: '5_57',
    name: 'HR Operations',
    levelId: 'role_k150',
  },
  {
    id: '7_1',
    name: 'Academic Researcher',
    levelId: 'role_k150',
  },
  {
    id: '8_126',
    name: 'Sales Representative',
    levelId: 'role_k150',
  },
  {
    id: '10_132',
    name: 'Software Engineer',
    levelId: 'role_k150',
  },
] as const;

// Custom: ONET // ONET
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_61: TreeFilter['selections'] =
  [
    {
      id: '1_3',
      name: 'Operations Specialties Managers',
      levelId: 'role_k150',
    },
    {
      id: '3_7',
      name: 'Computer Occupations',
      levelId: 'role_k150',
    },
    {
      id: '5_15',
      name: 'Life, Physical, and Social Science Technicians',
      levelId: 'role_k150',
    },
    {
      id: '16_58',
      name: 'Sales Representatives, Wholesale and Manufacturing',
      levelId: 'role_k150',
    },
  ] as const;

// Custom: ESCO // ESCO
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_62: TreeFilter['selections'] =
  [
    {
      id: '2_5',
      name: 'Administrative and Commercial Managers',
      levelId: 'role_k150',
    },
    {
      id: '3_10',
      name: 'Teaching Professionals',
      levelId: 'role_k150',
    },
    {
      id: '3_12',
      name: 'Information and Communications Technology Professionals',
      levelId: 'role_k150',
    },
    {
      id: '4_16',
      name: 'Business and Administration Associate Professionals',
      levelId: 'role_k150',
    },
  ] as const;

// Custom: LIGHTCAST // LIGHTCAST
export const GENERATED_DEFAULT_CUSTOM_ROLE_CUSTOM_63: TreeFilter['selections'] =
  [
    {
      id: '10_68',
      name: 'Financial Analysis',
      levelId: 'role_k150',
    },
    {
      id: '13_111',
      name: 'Human Resources Managers',
      levelId: 'role_k150',
    },
    {
      id: '14_118',
      name: 'Network and Systems Engineering',
      levelId: 'role_k150',
    },
    {
      id: '23_164',
      name: 'Technical Sales',
      levelId: 'role_k150',
    },
    {
      id: '24_168',
      name: 'General Research',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Industrial Infrastructure // Industrial Infrastructure
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_6: TreeFilter['selections'] =
  [
    {
      id: '1_116',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '9_50',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '9_57',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '11_127',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '12_121',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Professional Services // Professional Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_8: TreeFilter['selections'] =
  [
    {
      id: '1_64',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '4_119',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '5_59',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '11_127',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_134',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Public Sector Services // Public Sector Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_9: TreeFilter['selections'] =
  [
    {
      id: '1_68',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '2_121',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '5_63',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_131',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '8_1',
      name: 'Academic Coordinator',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Consumer Services and Hospitality // Consumer Services and Hospitality
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_1: TreeFilter['selections'] =
  [
    {
      id: '1_51',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '1_133',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_65',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '5_24',
      name: 'Content Creator',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Finance // Finance
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_4: TreeFilter['selections'] =
  [
    {
      id: '3_55',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_66',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '10_128',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_121',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '12_137',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Healthcare // Healthcare
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_5: TreeFilter['selections'] =
  [
    {
      id: '1_54',
      name: 'Finance',
      levelId: 'role_k150',
    },
    {
      id: '1_60',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '2_138',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '3_131',
      name: 'Researcher',
      levelId: 'role_k150',
    },
    {
      id: '11_69',
      name: 'Insurance Sales Agent',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Creative Services and Media // Creative Services and Media
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_2: TreeFilter['selections'] =
  [
    {
      id: '4_121',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '7_128',
      name: 'Sales Agent',
      levelId: 'role_k150',
    },
    {
      id: '9_62',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_144',
      name: 'Talent Planner',
      levelId: 'role_k150',
    },
    {
      id: '12_136',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Other // Other
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_0: TreeFilter['selections'] =
  [
    {
      id: '1_56',
      name: 'Human Resources Manager',
      levelId: 'role_k150',
    },
    {
      id: '7_46',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_114',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '7_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_122',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Telecommunications // Telecommunications
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_10: TreeFilter['selections'] =
  [
    {
      id: '1_59',
      name: 'HR Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_54',
      name: 'Financial Manager',
      levelId: 'role_k150',
    },
    {
      id: '9_77',
      name: 'Media Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '9_119',
      name: 'Sales Specialist',
      levelId: 'role_k150',
    },
    {
      id: '10_127',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Environmental Services // Environmental Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_3: TreeFilter['selections'] =
  [
    {
      id: '1_134',
      name: 'Talent Management',
      levelId: 'role_k150',
    },
    {
      id: '4_52',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '10_41',
      name: 'Environmental Researcher',
      levelId: 'role_k150',
    },
    {
      id: '11_123',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '12_127',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K10: Legal Services // Legal Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K10_7: TreeFilter['selections'] =
  [
    {
      id: '1_60',
      name: 'Finance Operations',
      levelId: 'role_k150',
    },
    {
      id: '2_72',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '4_153',
      name: 'Technical Writer',
      levelId: 'role_k150',
    },
    {
      id: '10_139',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '12_77',
      name: 'Healthcare Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Education Services // Education Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_15: TreeFilter['selections'] =
  [
    {
      id: '2_1',
      name: 'Academic Researcher',
      levelId: 'role_k150',
    },
    {
      id: '4_57',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_135',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '7_122',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
    {
      id: '9_63',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Healthcare and Wellness // Healthcare and Wellness
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_25: TreeFilter['selections'] =
  [
    {
      id: '1_143',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '3_59',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_67',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '6_90',
      name: 'Marketing Researcher',
      levelId: 'role_k150',
    },
    {
      id: '9_135',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Information Technology // Information Technology
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_31: TreeFilter['selections'] =
  [
    {
      id: '4_56',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '5_59',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '10_39',
      name: 'Direct Sales Agent',
      levelId: 'role_k150',
    },
    {
      id: '11_115',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '11_130',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Finance // Finance
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_21: TreeFilter['selections'] =
  [
    {
      id: '1_75',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '3_66',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_49',
      name: 'Economic Analyst',
      levelId: 'role_k150',
    },
    {
      id: '11_131',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_140',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Engineering and Construction // Engineering and Construction
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_18: TreeFilter['selections'] =
  [
    {
      id: '1_62',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '2_55',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_117',
      name: 'Sales Associate',
      levelId: 'role_k150',
    },
    {
      id: '6_110',
      name: 'Research Assistant',
      levelId: 'role_k150',
    },
    {
      id: '11_128',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Energy and Resources // Energy and Resources
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_17: TreeFilter['selections'] =
  [
    {
      id: '2_65',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '4_116',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '5_57',
      name: 'Financial Management Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_128',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_121',
      name: 'Sales Associate',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Public Sector Management // Public Sector Management
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_43: TreeFilter['selections'] =
  [
    {
      id: '4_59',
      name: 'Finance Strategy Manager',
      levelId: 'role_k150',
    },
    {
      id: '6_68',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '9_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_116',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '12_131',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Retail and Consumer Goods // Retail and Consumer Goods
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_47: TreeFilter['selections'] =
  [
    {
      id: '1_60',
      name: 'HR Payroll',
      levelId: 'role_k150',
    },
    {
      id: '4_52',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_33',
      name: 'Creative Content Creator',
      levelId: 'role_k150',
    },
    {
      id: '11_45',
      name: 'Direct Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_136',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Hospitality and Tourism // Hospitality and Tourism
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_26: TreeFilter['selections'] =
  [
    {
      id: '1_138',
      name: 'Talent Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '5_48',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_132',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '12_120',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_149',
      name: 'Visual Designer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Electronics Manufacturing // Electronics Manufacturing
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_16: TreeFilter['selections'] =
  [
    {
      id: '1_52',
      name: 'HR Leader',
      levelId: 'role_k150',
    },
    {
      id: '3_109',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '4_49',
      name: 'Financial Manager',
      levelId: 'role_k150',
    },
    {
      id: '6_127',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_113',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Logistics and Transportation // Logistics and Transportation
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_34: TreeFilter['selections'] =
  [
    {
      id: '1_47',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_60',
      name: 'HR Director',
      levelId: 'role_k150',
    },
    {
      id: '6_114',
      name: 'Research Assistant',
      levelId: 'role_k150',
    },
    {
      id: '8_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Food and Beverage // Food and Beverage
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_23: TreeFilter['selections'] =
  [
    {
      id: '1_47',
      name: 'Finance Manager',
      levelId: 'role_k150',
    },
    {
      id: '1_64',
      name: 'Human Resources Manager',
      levelId: 'role_k150',
    },
    {
      id: '4_25',
      name: 'Content Developer',
      levelId: 'role_k150',
    },
    {
      id: '9_134',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_127',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Apparel Retail // Apparel Retail
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_3: TreeFilter['selections'] =
  [
    {
      id: '1_59',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '3_47',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_24',
      name: 'Creative Writer',
      levelId: 'role_k150',
    },
    {
      id: '8_134',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Sales Specialist',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Other // Other
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_0: TreeFilter['selections'] =
  [
    {
      id: '2_2',
      name: 'Accountant',
      levelId: 'role_k150',
    },
    {
      id: '5_57',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '7_1',
      name: 'Academic Researcher',
      levelId: 'role_k150',
    },
    {
      id: '8_126',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Miscellaneous // Miscellaneous
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_38: TreeFilter['selections'] =
  [
    {
      id: '2_2',
      name: 'Accountant',
      levelId: 'role_k150',
    },
    {
      id: '7_1',
      name: 'Academic Researcher',
      levelId: 'role_k150',
    },
    {
      id: '7_57',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '8_126',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '10_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Human Resources // Human Resources
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_27: TreeFilter['selections'] =
  [
    {
      id: '3_115',
      name: 'Researcher',
      levelId: 'role_k150',
    },
    {
      id: '3_129',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_55',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_138',
      name: 'Talent Strategists',
      levelId: 'role_k150',
    },
    {
      id: '12_119',
      name: 'Sales Agent',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Professional Development Services // Professional Development Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_41: TreeFilter['selections'] =
  [
    {
      id: '3_111',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '4_125',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '5_45',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_55',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '11_146',
      name: 'Technical Sales',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Media and Entertainment // Media and Entertainment
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_37: TreeFilter['selections'] =
  [
    {
      id: '1_65',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '2_55',
      name: 'Finance Executive',
      levelId: 'role_k150',
    },
    {
      id: '2_130',
      name: 'Specialized Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_33',
      name: 'Cultural Curator',
      levelId: 'role_k150',
    },
    {
      id: '11_46',
      name: 'Direct Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Industrial Manufacturing // Industrial Manufacturing
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_30: TreeFilter['selections'] =
  [
    {
      id: '1_51',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '2_44',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '7_117',
      name: 'Research Technician',
      levelId: 'role_k150',
    },
    {
      id: '11_32',
      name: 'Direct Sales Rep',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Facility Management Services // Facility Management Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_20: TreeFilter['selections'] =
  [
    {
      id: '1_63',
      name: 'HR Administration',
      levelId: 'role_k150',
    },
    {
      id: '4_56',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '5_117',
      name: 'Research Writer',
      levelId: 'role_k150',
    },
    {
      id: '10_124',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_138',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Automotive Services // Automotive Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_6: TreeFilter['selections'] =
  [
    {
      id: '1_54',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '3_129',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_46',
      name: 'Finance Operations',
      levelId: 'role_k150',
    },
    {
      id: '10_20',
      name: 'Business Strategist',
      levelId: 'role_k150',
    },
    {
      id: '10_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: IT Consulting // IT Consulting
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_29: TreeFilter['selections'] =
  [
    {
      id: '4_50',
      name: 'Finance Manager',
      levelId: 'role_k150',
    },
    {
      id: '5_105',
      name: 'Research Communicator',
      levelId: 'role_k150',
    },
    {
      id: '5_132',
      name: 'Talent Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '10_41',
      name: 'Direct Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_119',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Real Estate and Development // Real Estate and Development
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_45: TreeFilter['selections'] =
  [
    {
      id: '3_47',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_28',
      name: 'Creative Researcher',
      levelId: 'role_k150',
    },
    {
      id: '8_54',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '9_139',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '12_132',
      name: 'Sales Specialist',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Digital Commerce // Digital Commerce
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_14: TreeFilter['selections'] =
  [
    {
      id: '5_54',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '5_57',
      name: 'HR Planner',
      levelId: 'role_k150',
    },
    {
      id: '7_24',
      name: 'Content Writer',
      levelId: 'role_k150',
    },
    {
      id: '11_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_127',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Marketing and Advertising // Marketing and Advertising
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_35: TreeFilter['selections'] =
  [
    {
      id: '1_66',
      name: 'Financial Planner',
      levelId: 'role_k150',
    },
    {
      id: '1_71',
      name: 'HR Strategist',
      levelId: 'role_k150',
    },
    {
      id: '2_87',
      name: 'Media Research',
      levelId: 'role_k150',
    },
    {
      id: '4_45',
      name: 'Digital Content Creator',
      levelId: 'role_k150',
    },
    {
      id: '11_53',
      name: 'Direct Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Consulting and Advisory Services // Consulting and Advisory Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_10: TreeFilter['selections'] =
  [
    {
      id: '1_58',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_141',
      name: 'Talent Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '7_132',
      name: 'Software Engineering',
      levelId: 'role_k150',
    },
    {
      id: '8_117',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '12_45',
      name: 'Direct Sales Rep',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Pharmaceuticals // Pharmaceuticals
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_40: TreeFilter['selections'] =
  [
    {
      id: '2_141',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '3_32',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_146',
      name: 'Talent Development',
      levelId: 'role_k150',
    },
    {
      id: '11_137',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
    {
      id: '12_127',
      name: 'Research Specialist',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Aerospace and Defense // Aerospace and Defense
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_1: TreeFilter['selections'] =
  [
    {
      id: '1_51',
      name: 'Financial Strategist',
      levelId: 'role_k150',
    },
    {
      id: '1_55',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '3_130',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_126',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
    {
      id: '11_136',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Humanitarian Services // Humanitarian Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_28: TreeFilter['selections'] =
  [
    {
      id: '2_62',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '5_69',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '9_134',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '10_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_81',
      name: 'Linguistic Researcher',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Telecommunications // Telecommunications
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_49: TreeFilter['selections'] =
  [
    {
      id: '1_60',
      name: 'HR Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_54',
      name: 'Financial Management Analyst',
      levelId: 'role_k150',
    },
    {
      id: '8_26',
      name: 'Communications Manager',
      levelId: 'role_k150',
    },
    {
      id: '8_119',
      name: 'Sales Specialist',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Wellness Products // Wellness Products
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_50: TreeFilter['selections'] =
  [
    {
      id: '1_56',
      name: 'Human Resources Manager',
      levelId: 'role_k150',
    },
    {
      id: '7_46',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_114',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '7_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_122',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Materials Manufacturing // Materials Manufacturing
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_36: TreeFilter['selections'] =
  [
    {
      id: '4_36',
      name: 'Finance Manager',
      levelId: 'role_k150',
    },
    {
      id: '5_43',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '6_129',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_114',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '11_126',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Legal Services // Legal Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_33: TreeFilter['selections'] =
  [
    {
      id: '1_63',
      name: 'Financial Operations Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_74',
      name: 'HR Specialist',
      levelId: 'role_k150',
    },
    {
      id: '4_132',
      name: 'Research Writer',
      levelId: 'role_k150',
    },
    {
      id: '10_142',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_79',
      name: 'Healthcare Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Biotechnology and Healthcare // Biotechnology and Healthcare
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_7: TreeFilter['selections'] =
  [
    {
      id: '1_49',
      name: 'HR Operations Leadership',
      levelId: 'role_k150',
    },
    {
      id: '2_135',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_44',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_133',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_125',
      name: 'Research Scientist',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Business Services // Business Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_8: TreeFilter['selections'] =
  [
    {
      id: '1_85',
      name: 'Media Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_57',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_67',
      name: 'HR Management',
      levelId: 'role_k150',
    },
    {
      id: '8_137',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_139',
      name: 'Specialized Sales',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Design and Printing Services // Design and Printing Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_13: TreeFilter['selections'] =
  [
    {
      id: '1_66',
      name: 'HR Trainer',
      levelId: 'role_k150',
    },
    {
      id: '2_33',
      name: 'Cultural Interpreter',
      levelId: 'role_k150',
    },
    {
      id: '4_60',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_133',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '11_67',
      name: 'Healthcare Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Culture and Entertainment // Culture and Entertainment
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_12: TreeFilter['selections'] =
  [
    {
      id: '3_74',
      name: 'HR Strategist',
      levelId: 'role_k150',
    },
    {
      id: '6_35',
      name: 'Cultural Curator',
      levelId: 'role_k150',
    },
    {
      id: '6_87',
      name: 'Multimedia Developer',
      levelId: 'role_k150',
    },
    {
      id: '11_62',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '11_120',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Environmental Services // Environmental Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_19: TreeFilter['selections'] =
  [
    {
      id: '1_61',
      name: 'HR Director',
      levelId: 'role_k150',
    },
    {
      id: '1_115',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_129',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '4_129',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_51',
      name: 'Finance Manager',
      levelId: 'role_k150',
    },
    {
      id: '12_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Commercial Aviation // Commercial Aviation
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_9: TreeFilter['selections'] =
  [
    {
      id: '1_59',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_47',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_25',
      name: 'Content Creator',
      levelId: 'role_k150',
    },
    {
      id: '9_118',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_128',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Packaging Services // Packaging Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_39: TreeFilter['selections'] =
  [
    {
      id: '1_43',
      name: 'Finance',
      levelId: 'role_k150',
    },
    {
      id: '1_51',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '5_22',
      name: 'Creative Strategist',
      levelId: 'role_k150',
    },
    {
      id: '10_131',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '11_122',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Automation Solutions // Automation Solutions
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_5: TreeFilter['selections'] =
  [
    {
      id: '1_61',
      name: 'HR Professional',
      levelId: 'role_k150',
    },
    {
      id: '4_54',
      name: 'Finance Operations',
      levelId: 'role_k150',
    },
    {
      id: '5_131',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '7_118',
      name: 'Research and Development Intern',
      levelId: 'role_k150',
    },
    {
      id: '11_122',
      name: 'Sales Consultant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Agriculture // Agriculture
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_2: TreeFilter['selections'] =
  [
    {
      id: '2_30',
      name: 'Corporate Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '3_57',
      name: 'HR Director',
      levelId: 'role_k150',
    },
    {
      id: '9_116',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '10_128',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_135',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Research and Development // Research and Development
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_46: TreeFilter['selections'] =
  [
    {
      id: '1_133',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '4_63',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '5_58',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_140',
      name: 'Software Engineers',
      levelId: 'role_k150',
    },
    {
      id: '12_119',
      name: 'Research Assistant',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Sports Management // Sports Management
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_48: TreeFilter['selections'] =
  [
    {
      id: '3_36',
      name: 'Cultural Interpreter',
      levelId: 'role_k150',
    },
    {
      id: '3_47',
      name: 'Digital Content Developer',
      levelId: 'role_k150',
    },
    {
      id: '4_60',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '9_122',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '11_69',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Professional and Trade Associations // Professional and Trade Associations
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_42: TreeFilter['selections'] =
  [
    {
      id: '1_113',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '4_51',
      name: 'Financial Advisor',
      levelId: 'role_k150',
    },
    {
      id: '6_132',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '10_59',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '12_116',
      name: 'Sales Associate',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Architectural Design Services // Architectural Design Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_4: TreeFilter['selections'] =
  [
    {
      id: '1_32',
      name: 'Cultural Writer',
      levelId: 'role_k150',
    },
    {
      id: '7_61',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '7_70',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '10_126',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_133',
      name: 'Software and Systems Engineer',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Consumer Technology Distribution // Consumer Technology Distribution
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_11: TreeFilter['selections'] =
  [
    {
      id: '1_104',
      name: 'Research Analyst',
      levelId: 'role_k150',
    },
    {
      id: '2_53',
      name: 'Financial Management and Accounting',
      levelId: 'role_k150',
    },
    {
      id: '3_123',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '6_133',
      name: 'Talent Strategists',
      levelId: 'role_k150',
    },
    {
      id: '10_108',
      name: 'Sales Agents',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Food and Hospitality // Food and Hospitality
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_24: TreeFilter['selections'] =
  [
    {
      id: '1_68',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '10_59',
      name: 'Financial Analyst',
      levelId: 'role_k150',
    },
    {
      id: '10_139',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '11_131',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
    {
      id: '12_119',
      name: 'Research Intern',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Quality Assurance and Testing Services // Quality Assurance and Testing Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_44: TreeFilter['selections'] =
  [
    {
      id: '1_107',
      name: 'Research Associate',
      levelId: 'role_k150',
    },
    {
      id: '3_41',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '6_51',
      name: 'HR Operations',
      levelId: 'role_k150',
    },
    {
      id: '9_130',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '11_124',
      name: 'Salesperson',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Fitness and Wellness // Fitness and Wellness
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_22: TreeFilter['selections'] =
  [
    {
      id: '1_63',
      name: 'Finance Analyst',
      levelId: 'role_k150',
    },
    {
      id: '1_78',
      name: 'HR Coordinator',
      levelId: 'role_k150',
    },
    {
      id: '6_37',
      name: 'Cultural Writer',
      levelId: 'role_k150',
    },
    {
      id: '10_136',
      name: 'Software Developer',
      levelId: 'role_k150',
    },
    {
      id: '11_128',
      name: 'Sales Representative',
      levelId: 'role_k150',
    },
  ] as const;

// K50: Language Services // Language Services
export const GENERATED_DEFAULT_CUSTOM_ROLE_RICS_K50_32: TreeFilter['selections'] =
  [
    {
      id: '1_116',
      name: 'Research Intern',
      levelId: 'role_k150',
    },
    {
      id: '2_114',
      name: 'Recruitment Operations',
      levelId: 'role_k150',
    },
    {
      id: '3_134',
      name: 'Software Engineer',
      levelId: 'role_k150',
    },
    {
      id: '5_50',
      name: 'Financial Accountant',
      levelId: 'role_k150',
    },
    {
      id: '12_122',
      name: 'Sales Executive',
      levelId: 'role_k150',
    },
  ] as const;
